import { Typography } from "@voicely/ui-mui/data-display/Typography";
import { Box } from "@voicely/ui-mui/layout/Box";

/**
 * A raw object behind a native `<details>` disclosure.
 *
 * The dump pages interpret the fields worth interpreting; everything else is
 * still evidence somebody may need verbatim, and re-modelling every vendor
 * payload as components would be a rendering layer to keep in step with
 * schemas that change under it. Collapsed by default so the interpreted view
 * stays the page.
 */
export const JsonDetails = ({ label, value }: { label: string; value: unknown }) => (
	<Box
		component="details"
		sx={{
			border: "1px solid",
			borderColor: "surface.border",
			borderRadius: 2,
			px: 2,
			py: 1,
			"& > summary": { cursor: "pointer" },
		}}
	>
		<Typography component="summary" variant="body2" sx={{ fontWeight: 600 }}>
			{label}
		</Typography>
		<Box
			component="pre"
			sx={{
				m: 0,
				mt: 1,
				p: 1.5,
				fontSize: 12,
				lineHeight: 1.5,
				overflowX: "auto",
				bgcolor: "surface.sunken",
				borderRadius: 1.5,
			}}
		>
			{JSON.stringify(value, null, 2)}
		</Box>
	</Box>
);
